import * as React from 'react';

import { LocalStorageKeys, safeGetItem, safeSetItem } from 'pages/views/devices/utils/storage';

export function useLocalStorage<Type>(key: LocalStorageKeys, defaultValue: Type) {
  const [value, setValue] = React.useState<Type | undefined>(() => safeGetItem(key, defaultValue));

  React.useEffect(() => {
    safeSetItem(key, value);
  }, [value, key]);

  return [value, setValue] as const;
}
